import { render, staticRenderFns } from "./ProjectResource.vue?vue&type=template&id=69175190&"
import script from "./ProjectResource.vue?vue&type=script&lang=js&"
export * from "./ProjectResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports